
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docx-to-flashcards",
      function () {
        return require("private-next-pages/docx-to-flashcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docx-to-flashcards"])
      });
    }
  